import { queryOptions } from '@tanstack/react-query';

import { insuranceApi } from '../apis/insurance';
import { Globals } from '../hooks/use-queries-with-globals/queries-with-global';
import { Filters } from '../utils/format-filters';

export const insuranceQueries = (globals: Globals) => ({
  all: [globals, 'insurance'],

  lists: () => [...insuranceQueries(globals).all, 'list'],
  list: (args: { filters: Filters }) =>
    queryOptions({
      queryKey: [...insuranceQueries(globals).lists(), args.filters],
      queryFn: () => insuranceApi.getAll(args),
    }),
});
